import React, { useMemo } from "react";
import { formatTableCellValue } from "../utils";
const MisReportTable = ({ title, data }) => {
  const MONTH_ORDER = useMemo(
    () => ({
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    }),
    [],
  );

  const isMisNetRow = (description = "") => {
    const lower = description.toLowerCase();
    return lower.startsWith("closing balance") || lower.startsWith("net cash");
  };

  const columns = useMemo(() => {
    if (!data || data.length === 0) return [];
    const firstRow = data[0];
    const allColumns = Object.keys(firstRow).filter(
      (key) => key !== "Description",
    );

    return allColumns.sort((a, b) => {
      const monthA = a.split("_")[0];
      const monthB = b.split("_")[0];
      return MONTH_ORDER[monthA] - MONTH_ORDER[monthB];
    });
  }, [data, MONTH_ORDER]);

  const isMisTotalRow = (description = "") => {
    const lower = description.toLowerCase();
    return lower.startsWith("total");
  };

  if (!data || data.length === 0) return null;

  return (
    <div className="rounded-2xl border border-[#EFD99A] bg-white shadow-sm">
      <div className="border-b border-[#EFD99A] px-4 py-3">
        <h2 className="text-lg font-semibold text-[#412402]">
          {title} — ₹ Crores
        </h2>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-slate-700">
          <thead className="bg-[#854F0B] text-left text-xs font-semibold uppercase tracking-wider text-[#FAEEDA]">
            <tr>
              <th className="w-1/3 px-4 py-3">Description</th>
              {columns.map((col) => (
                <th key={col} className="px-4 py-3 text-right">
                  {col.replace(/_/g, " ")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const isNet = isMisNetRow(row.Description);
              const isTotal = isMisTotalRow(row.Description);

              if (isNet) {
                return (
                  <tr
                    key={`${row.Description}-${index}`}
                    className="border-t-2 border-[#633806]"
                  >
                    <td className="px-4 py-2.5 font-bold text-[#FAEEDA] bg-[#854F0B]">
                      {row.Description}
                    </td>
                    {columns.map((col) => (
                      <td
                        key={col}
                        className="px-4 py-2.5 text-right font-mono font-bold text-[#FAEEDA] bg-[#854F0B]"
                      >
                        {formatTableCellValue(row[col])}
                      </td>
                    ))}
                  </tr>
                );
              }

              if (isTotal) {
                return (
                  <tr
                    key={`${row.Description}-${index}`}
                    className="border-t-2 border-[#EF9F27]"
                  >
                    <td className="px-4 py-2.5 font-bold text-[#412402] bg-[#FAC775]">
                      {row.Description}
                    </td>
                    {columns.map((col) => (
                      <td
                        key={col}
                        className="px-4 py-2.5 text-right font-mono font-bold text-[#412402] bg-[#FAC775]"
                      >
                        {formatTableCellValue(row[col])}
                      </td>
                    ))}
                  </tr>
                );
              }

              return (
                <tr
                  key={`${row.Description}-${index}`}
                  className="border-t border-[#FAF0DC] hover:bg-[#FEF8EE]"
                >
                  <td className="px-4 py-2.5 font-medium text-[#5a3a1a]">
                    {row.Description}
                  </td>
                  {columns.map((col) => {
                    const value = Number(row[col]);
                    return (
                      <td
                        key={col}
                        className={`px-4 py-2.5 text-right font-mono ${
                          !isTotal && !isNet && value < 0 ? "text-red-700" : ""
                        } ${!isTotal && !isNet && value > 0 ? "text-emerald-700" : ""}`}
                      >
                        {formatTableCellValue(row[col])}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MisReportTable;
